let util = {

};
util.title = function (title) {
    title = title ? title + '' : 'Cerrajeros Urgentes, electricistas, fontaneros, desatascos 24h';
    window.document.title = title;
};

export default util;


// WEBPACK FOOTER //
// ./src/libs/util.js